<div
  class="theory"
  [innerHTML]="theory() | lyceoRemoveWhitespace | kbModuleLink"
></div>
@if (showCheckbox()) {
  <lyceo-checkbox [checked]="readTheory()" (checkedChange)="setHasReadTheory()">
    Ik heb de theorie gelezen en begrijp wat er wordt uitgelegd.
  </lyceo-checkbox>
}
